import React, { useState } from 'react';
import UninstallTable from '../../Tables/TablesList/UninstallsTable/uninstallTable';
import { useParams } from 'react-router-dom';
import { SelectableTag } from '../../Utils/Components/selectableTag';
import AggregatedUninstalls from '../../Tables/TablesList/UninstallsTable/aggregatedUninstallTable';

export const ExtensionUninstalls = () => {
	const { id } = useParams();

	const tags = ['all', 'aggregated'];

	const [selectedTag, setSelectedTag] = useState<string>(tags[0]);

	return (
		<div className="pt-16 pl-16">
			<div className="pl-4 pt-4 flex flex-row space-x-3">
				{tags.map((tag) => (
					<SelectableTag
						name={tag}
						selectedTag={selectedTag}
						setSelectedTag={setSelectedTag}
					/>
				))}
			</div>
			{selectedTag === 'all' ? (
				<UninstallTable extensionId={id} />
			) : (
				<AggregatedUninstalls extensionId={id} />
			)}
		</div>
	);
};
